import { createSlice } from '@reduxjs/toolkit';
import { SetPageTitleAction, AppState, ToggleDialogActiveAction } from './types';
import { hasEmptyValue } from 'Lib/Any';

const name = 'app';

const initialState: AppState = {
  pageTitle: {},
  activeDialogs: [],
};

/**
 * This slice manages general state of the web app
 * (i.e. state affecting its operation as a browser app)
 */
const slice = createSlice({
  name,
  initialState,
  reducers: {
    /**
     * Set the app's current page title
     */
    setPageTitle: (state, action: SetPageTitleAction) => {
      if (hasEmptyValue(action.payload.pageTitle)) {
        delete state.pageTitle[action.payload.source];
      } else {
        state.pageTitle[action.payload.source] = action.payload.pageTitle;
      }
    },
    setDialogActive: (state, action: ToggleDialogActiveAction) => {
      state.activeDialogs.push(action.payload.dialogId);
    },
    setDialogInactive: (state, action: ToggleDialogActiveAction) => {
      // A dialog may deactivate itself when it isn't the most recently activated dialog.
      // Remove it no matter where it is.
      state.activeDialogs = state.activeDialogs.filter((d) => d !== action.payload.dialogId);
    },
  },
});

const { actions, reducer } = slice;
export { actions, reducer };
